// extracted by mini-css-extract-plugin
module.exports = {"root":"Columns_root__wmGm2","loader":"Columns_loader__1xI5W"};